import type { FaireProductEntity } from "../../entity_types/product";

export const p_un3kt7m35q: FaireProductEntity = {
  token: "p_un3kt7m35q",
  type: "product",
  name: "Boho Casual Patchwork Backpack Eco-Friendly Multi-Purpose Bag",
  brandToken: "b_9jg4fbzgpg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/750e5bdf0bf4a67e59dadc843e9d4f00f661abd5d46f28d2a1fdf5e5601e67f1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a6eba422037082466adc9dd71e660ec4bb959fc57d5d505cae913979111130d4.jpeg",
    "https://cdn.faire.com/fastly/8654e817f40ac8299f20d0a0b9f4e7a0c9db516abaf98f7476ec0cb8831b62d7.jpeg",
    "https://cdn.faire.com/fastly/f788d2bab80a50b940ba8e923a581a34b18cd5895159148abc6c2b73ca08bdc0.jpeg",
    "https://cdn.faire.com/fastly/4c72ea331104afd6a106afce3473c451fbfa9ac3fcdf6de9414a4c1a51cdde5e.jpeg",
    "https://cdn.faire.com/fastly/26b2b5e7bf4218dccfc5402eb46785b2186005aaf278da1b919a39302645f71d.jpeg",
    "https://cdn.faire.com/fastly/a66a86ead570172819bb61fcfb7274b426a70902c6145d8a80f010e4de3083ef.jpeg",
    "https://cdn.faire.com/fastly/b506e2c967308a90e25b02cbe0eb9aa9f8885184db99fd63e0bea7fbfe64cfac.jpeg",
    "https://cdn.faire.com/fastly/0b63fbdf934cd804d0e0f8e1986741d7d8feb28c3a9cd9e786f5d6887b9431b8.jpeg",
    "https://cdn.faire.com/fastly/98b55b31964fe9291b6d632c7765b9d6d8cd39092337a14dd9d4968b72bde078.jpeg",
  ],
  priceDollars: 25,
  description:
    "\nThis adorable mini backpack is the only backpack you’ll need for biking, traveling, hiking, music festivals, yoga, and more! These eco-friendly backpacks are made of cotton fabric, making them soft and durable. We believe that the function of a backpack is VERY important and customers always have nothing but praise for the quality of our products. Handmade with the love and dedication from artisans in Nepal, the profit we make from our products also goes back to support the artisans as well as their children. So not only will you be happy with the quality of our backpacks, but you’ll also know that you’re benefitting a good cause. Besides its spacious main compartment, there is also an additional slightly smaller pocket on the front of the backpack that showcases its beautifully detailed design.",
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:40.102Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
